import {WebGl2ImagePhysical} from "#webgl2/webgl2-image-physical"
import type {WebGl2Image} from "#webgl2/webgl2-image"
import {WebGl2ImageVirtual} from "#webgl2/webgl2-image-virtual"
import {WebGl2ImageView} from "#webgl2/webgl2-image-view"

export const isWebGl2Image = (data: unknown): data is WebGl2Image => {
    return data instanceof WebGl2ImagePhysical || data instanceof WebGl2ImageVirtual || data instanceof WebGl2ImageView
}
